import { GridContainer } from 'libs/ui';
import { Violations } from 'grids/violations/violations';

export const ViolationsWrapper = (props) => {
  return (
    <GridContainer>
      <Violations {...props} />
    </GridContainer>
  );
};
